<template>
  <swiper 
    :options="swiperOption"
    class="hmt-carousel"
    @clickSlide="selectPhoto"
  >
    <swiper-slide
      v-for="photo in items"
      :key="photo.md"
    >
      <HMTImageWatermark
        v-if="getUnpaid" 
        :src="photo.md" 
      />
      <lazy-image 
        v-else 
        :src="photo.md" 
      />
      <div class="swiper-lazy-preloader swiper-lazy-preloader-black"></div>
    </swiper-slide>
  </swiper>
</template>

<script>
  import { mapGetters } from 'vuex';

  import HMTImageWatermark from '@/shared/components/ImageWatermark';

  export default {
    name: 'Carousel',
    components: {
      HMTImageWatermark
    },
    props: {
			items: {
				type: Array
			}
		},
    data() {
      return {
        swiperOption: {
          slidesPerView: 'auto',
          spaceBetween: 15
        }
      }
    },
    computed: {
      ...mapGetters('tour', ['getUnpaid'])
    },
    methods: {
      selectPhoto (photoIndex) {
        this.$emit('onSelectItem', photoIndex);
      }
    }
  };
</script>

<style lang="scss">
  .hmt-carousel {
    &:before, &:after {
      content: '';
      position: absolute;
      top: 0;
      z-index: 5;
      height: 100%;
      width: 20px;
    }

    &:before {
      left: -20px;
      box-shadow: 7px 0 10px 0 rgba(var(--gallery-carousel-shadow-color), .75);
    }

    &:after {
      right: -20px;
      box-shadow: -7px 0 10px 0 rgba(var(--gallery-carousel-shadow-color), .75);
    }

    .swiper-slide {
      width: 240px;
      height: 300px;

      img {
        position: relative;
        z-index: 30;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
</style>
